export default "__VITE_ASSET__D_iaZr8f__"